// extracted by mini-css-extract-plugin
export default {"Link":"Link-module__Link___3v451"};